<style>
	.isolation-dropdpwn .vs__dropdown-menu{
		max-height:60px;
	}
	.isolation-dropdpwn .vs__clear{
		display:none;
	}
	.stats-number{font-size:20px !important; font-weight:400 !important; line-height:1.1em;}
	.stats-number span{font-size:16px;}
</style>

<template>
	<div class="widget widget-stats mb-7px" v-if="isolation_statuses" :class="isolation_statuses.find(is => is.id == isolation.status).bg_class"> <!-- :class="{'bg-lime': !user,'bg-gray':user && isolation.user_id != user.id,'bg-success': user && isolation.user_id == user.id}" -->
		<div class="stats-icon stats-icon-lg">
			<i v-if="isolation.is_high_voltage == 1" class="fa fa-charging-station fa-fw"></i>
			<i v-else class="fa fa-bolt fa-fw"></i>
		</div>
		<div class="stats-content">
			<div class="stats-title text-truncate" :class="{'text-black-strict':[1,10,7].includes(isolation.status)}">
				<span v-if="isolation.active_temporary_reconnect == null">{{isolation_statuses.find(is => is.id == isolation.status).name }}</span>
				<span v-else>ideiglenesen feszültség alá helyezve</span>
				<span class="float-end"><span class="badge bg-secondary">#{{isolation.id}}</span></span>
				<span class="badge bg-danger rounded-pill" title="ideiglenesen feszültség alá helyezve" v-if="isolation.active_temporary_reconnect != null"><i class="fa-solid fa-plug fa-fade"></i></span>
			</div>
			<div class="stats-number text-truncate" v-b-tooltip.hover 
			:title="isolation.position_ddcid+' | '+isolation.name+(isolation.is_high_voltage == 1 ? (' '+isolation.station+'/'+isolation.cells.join(',')) : '')" 
			:class="{'text-black-strict':[1,10,7].includes(isolation.status)}">
				{{isolation.position_ddcid}} 
				<span class="badge bg-dark fs-9px" v-if="isolation.is_high_voltage == 1">
					{{isolation.station}}/{{isolation.cells.join(',')}}
				</span>
				<br>
				<span>{{ isolation.name }}</span>
			</div>
			<v-select v-if="edit" :class="isolation_statuses.find(is => is.id == isolation.status).bg_class" class="bg-opacity-50 bg-gradient mb-30px isolation-dropdpwn" :options="electricians" label="name" v-model="emitobject.user_id" @input="electricianSelected()" :reduce="(option) => option.id">
				<template #search="{attributes, events}">
					<input
						class="vs__search fw-bold"
						:class="{'text-white': ![1,10,7].includes(isolation.status)}"
						v-bind="attributes"
						v-on="events"
						:placeholder="!emitobject.user_id ? 'Válassz Villanyszerelőt!' : ''"
					/>
				</template>
			</v-select>
			<div class="stats-desc" :class="{'text-black-strict':[1,10,7].includes(isolation.status)}">
				{{ isolation.created_at }}
				<h6 title="Villanyszerelő" class="text-truncate"><i class="fa fa-screwdriver-wrench"></i> {{isolation.user_name ? isolation.user_name : 'nincs villanyszerelőhöz rendelve'}}</h6>
			</div>
			<div class="stats-link" v-if="user">
				<a v-if="isolation.first_task_id" href="javascript:;" @click="isolationLink(isolation)">
					<span>Részletek </span>
					<i class="fa fa-arrow-alt-circle-right"></i>
				</a>
				<a v-else>
					Hiányzó operátor
					<i class="fa fa-exclamation-triangle"></i> 
				</a>
			</div>
		</div>
	</div>
</template>

<script>
import Isolation from '../apis/Isolation.js'	
export default {
	props: { isolation: Object, edit:Boolean, electricians:Array},
	data() {
		return {
			isolation_statuses:false,
		}
	},
	computed:{
		user(){
			return this.$store.state.user;
		},
		emitobject(){
			return {user_id: this.isolation.user_id};
		}
	},
	created(){
		//this.$set(this.emitobject,'user_id',this.isolation.user_id);
		this.isolation_statuses = JSON.parse(localStorage.getItem('constants')).isolation_status;
	},
	methods: {
		electricianSelected(){
			this.$emit('electricianselected', this.emitobject);
		},
		isolationLink(isolation){
			if(this.user.id == isolation.user_id && isolation.status < 3){
				Isolation.statusUpdate(isolation.id,{status:'electrician_accepted'});
			}
			this.$router.push({ path: '/isolations/'+isolation.id+'/edit' });

		}
	}
};
</script>